import { Injectable } from '@angular/core';
import { CanMatch, Route } from '@angular/router';
import { LocaleService } from '@shared/lib/services/locale.service';
import { UsanaMarketService } from '@usana/ux/markets';
import { firstValueFrom } from 'rxjs';

/**
 * Route guard that controls whether a route matches based on CMS market status.
 *
 * Caches the resolved CMS state after the first async resolution so that
 * subsequent canMatch calls during the same navigation are synchronous.
 * Resets automatically when the locale changes.
 */
@Injectable({ providedIn: 'root' })
export class CmsTypeGuard implements CanMatch {
  private resolved = false;
  private isCmsMarket = false;
  private lastLocale = '';

  constructor(
    private readonly localeService: LocaleService,
    private readonly usanaMarketService: UsanaMarketService,
  ) {}

  async canMatch(route: Route): Promise<boolean> {
    if (!this.resolved || this.localeService.getLocale() !== this.lastLocale) {
      await firstValueFrom(this.usanaMarketService.geti18NInfoSubject());
      await firstValueFrom(this.localeService.getLocaleObservable());
      this.isCmsMarket = this.localeService.isCms();
      this.lastLocale = this.localeService.getLocale();
      this.resolved = true;
    }

    if (route.data?.cmsType === 'cms') {
      return this.isCmsMarket;
    }
    if (route.data?.cmsType === 'noncms') {
      return !this.isCmsMarket;
    }

    return true;
  }
}
